/**
 * Created by Ning Jiang on 12/12/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Power2, TimelineLite, TweenLite} from "gsap";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {TombstoneStrings} from "../../TombstoneStrings";

export class JusticeOutroWPView extends BaseView {

    private _youWonStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "66px",
        fontWeight : FontWeight.BOLD,
        fill : "#fff2a7",
        stroke : "#3d0025",
        strokeThickness : 5,
    };

    private _spinsPlayedStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "35px",
        fontWeight : FontWeight.BOLD,
        fill : "#fff2a7",
        stroke : "#3d0025",
        strokeThickness : 5,
    };

    private _layer:ScalableLayer;
    private _container:PIXI.Container;
    private _darkOverlay:PIXI.Graphics;
    private _noWin:PIXI.Sprite;
    private _youWinText:PIXI.Text;
    private _winAmonut:BitmapCountUp;
    private _spinsPlayed:PIXI.Text;
    private _starLeft:PIXI.Sprite;
    private _starRight:PIXI.Sprite;

    private _isShowing:boolean = false;
    private _isEndingCreated:boolean = false;
    private _showStar:boolean = false;

    private _showTimeline:TimelineLite;
    private _endingTimeline:TimelineLite;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.JUSTICE_OUTRO.name);
        this._container = new PIXI.Container();

        this._darkOverlay = new PIXI.Graphics;
        this._container.addChild(this._darkOverlay);

        this._noWin = new PIXI.Sprite(GameResources.getTextures("noJustice")[0]);
        this._noWin.anchor.set(0.5);
        this._noWin.position.set(0, -65);
        this._container.addChild(this._noWin);

        this._starLeft = new PIXI.Sprite(GameResources.getTextures("B1/B1")[0]);
        this._starLeft.anchor.set(0.5);
        this._starLeft.position.set(-340, -52);
        this._container.addChild(this._starLeft);

        this._starRight = new PIXI.Sprite(GameResources.getTextures("B2/B2")[0]);
        this._starRight.anchor.set(0.5);
        this._starRight.position.set(340, -52);
        this._container.addChild(this._starRight);

        this._youWinText = new PIXI.Text(` ${Translation.translate(TombstoneStrings.FS_YOU_WON_TEXT)} `, this._youWonStyle);
        this._youWinText.anchor.set(0.5);
        this._youWinText.position.set(0, -198);
        this._container.addChild(this._youWinText);

        this._winAmonut = new BitmapCountUp(
            {
                style : {
                    font : {name : "NumbersTombstone", size : 38},
                    tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
                }
            });
        this._winAmonut.shrinkSize = true;
        this._winAmonut.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._winAmonut.position.set(0, -52);
        this._container.addChild(this._winAmonut);

        this._spinsPlayed = new PIXI.Text("", this._spinsPlayedStyle);
        this._spinsPlayed.anchor.set(0.5);
        this._container.addChild(this._spinsPlayed);
    }

    protected onResize(resizeData:IResizeData):void {
        if(!this._isShowing) {
            this._isResizeDirty = true;
            return;
        }

        const screenWidth:number = resizeData.width / this._layer.scale.x;
        const screenHeight:number = resizeData.height / this._layer.scale.y;
        this._container.position.set(screenWidth * 0.5 - this._layer.x / this._layer.scale.x, screenHeight * 0.5 - this._layer.y / this._layer.scale.y);

        this._darkOverlay.clear();
        this._darkOverlay.beginFill(0x000000, 0.8);
        this._darkOverlay.drawRect(-screenWidth / 2, -screenHeight / 2, screenWidth, screenHeight);

        this._isResizeDirty = false;
    }

    public show(totalWin:number, spinsPlayed:number, isAnimate:boolean):TimelineLite {
        this._isShowing = true;

        if(totalWin > 0) {
            this._noWin.visible = false;
            this._starLeft.alpha = 0;
            this._starLeft.visible = true;
            this._starRight.alpha = 0;
            this._starRight.visible = true;
            this._youWinText.alpha = 0;
            this._youWinText.visible = true;
            this._winAmonut.alpha = 0;
            this._winAmonut.visible = true;
            this._winAmonut.getCountUpAnimation(totalWin, totalWin, {duration : 0});
            const starOffset:number = Math.floor(this._winAmonut.width / 2 + this._starLeft.width / 2 + 50);
            this._showStar = starOffset <= 360;
            this._starLeft.x = -starOffset;
            this._starRight.x = starOffset;
            this._spinsPlayed.position.set(0, 74);
        } else {
            this._noWin.alpha = 0;
            this._noWin.visible = true;
            this._starLeft.visible = false;
            this._starRight.visible = false;
            this._youWinText.visible = false;
            this._winAmonut.visible = false;
            this._spinsPlayed.position.set(0, 174);
        }

        this._spinsPlayed.alpha = 0;
        this._spinsPlayed.text = ` ${Translation.translate(TombstoneStrings.FS_SPINS_PLAYED)} ${spinsPlayed.toString()} `;

        if(this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        this._layer.addChild(this._container);
        this._container.alpha = 1;

        const timeline:TimelineLite = new TimelineLite({paused : true});
        if(totalWin > 0) {
            timeline.add([
                TweenLite.to(this._youWinText, isAnimate ? 0.2 : 0, {alpha : 1, ease : Power2.easeIn}),
                TweenLite.to(this._winAmonut, isAnimate ? 0.4 : 0, {alpha : 1, ease : Power2.easeIn}),
                TweenLite.to(this._spinsPlayed, isAnimate ? 0.8 : 0, {alpha : 1, ease : Power2.easeIn})
            ], 0);
            if(this._showStar) {
                timeline.add([
                    TweenLite.to(this._starLeft, isAnimate ? 0.2 : 0, {alpha : 1, ease : Power2.easeIn}),
                    TweenLite.to(this._starRight, isAnimate ? 0.2 : 0, {alpha : 1, ease : Power2.easeIn})
                ], 0);
            }
        } else {
            timeline.add([
                TweenLite.to(this._noWin, isAnimate ? 0.2 : 0, {alpha : 1, ease : Power2.easeIn}),
                TweenLite.to(this._spinsPlayed, isAnimate ? 0.6 : 0, {alpha : 1, ease : Power2.easeIn})
            ], 0);
        }

        this._showTimeline = timeline;
        return this._showTimeline;
    }

    public playEnding(totalWin:number, spinsPlayed:number, isAborted:boolean):TimelineLite {
        if(!this._isEndingCreated) {
            const timeline:TimelineLite = new TimelineLite({paused : true});
            timeline.add(() => {
                Logger.logDev("play ending when ending is not playing");
                if(!this._isShowing) {
                    this.show(totalWin, spinsPlayed, false);
                }
            });
            timeline.add(TweenLite.to(this._container, 0.8, {alpha : 0}));
            timeline.add(() => {
                this._isShowing = false;
                this._isEndingCreated = false;
                this._layer.removeChild(this._container);
            });
            this._endingTimeline = timeline;
            this._isEndingCreated = true;
        }
        if(isAborted) {
            Logger.logDev("abort abort.");
            if(this._showTimeline && this._showTimeline.isActive()) {
                Logger.logDev("killed showTimeline");
                this._showTimeline.pause();
                this._showTimeline.progress(1);
            }
            this._endingTimeline.timeScale(2);
            this._endingTimeline.play();
        }

        return this._endingTimeline;
    }
}